var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleLineWithBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#EEF9E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 26.668C47.3638 26.668 53.3334 32.6375 53.3334 40.0013C53.3334 47.365 47.3638 53.3346 40.0001 53.3346C32.6363 53.3346 26.6667 47.365 26.6667 40.0013C26.6667 32.6375 32.6363 26.668 40.0001 26.668ZM40.0001 29.3346C34.109 29.3346 29.3334 34.1103 29.3334 40.0013C29.3334 45.8924 34.109 50.668 40.0001 50.668C45.8911 50.668 50.6667 45.8924 50.6667 40.0013C50.6667 34.1103 45.8911 29.3346 40.0001 29.3346ZM44.7139 35.1763C45.2346 34.6556 46.0789 34.6556 46.5995 35.1763C47.0802 35.6569 47.1171 36.4132 46.7105 36.9363L46.5995 37.0619L39.1514 44.5101C38.6195 45.042 37.7808 45.08 37.2051 44.6241L37.0772 44.5101L33.4002 40.8332C32.8795 40.3125 32.8795 39.4682 33.4002 38.9476C33.8809 38.4668 34.6372 38.4299 35.1602 38.8366L35.2858 38.9476L38.1142 41.776L44.7139 35.1763Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleLineWithBackground);
export default __webpack_public_path__ + "static/media/check_circle_line_with_background.8b51d92dacb387c392e762e588dd2c13.svg";
export { ForwardRef as ReactComponent };